import React from 'react';
import { GiftIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
type Bonus = {
  n: string;
  emoji: string;
  title: string;
  intro: string;
  bullets?: string[];
  outro?: string;
  value: string;
  image?: string;
};
const BONUSES: Bonus[] = [{
  n: '1',
  emoji: '🧠',
  title: 'Kit de Algoritmos de Decisión Clínica',
  intro: 'Deja de consultar múltiples guías antes de cada consulta.',
  outro: 'Obtén algoritmos visuales que te indican exactamente qué hacer según el escenario clínico del paciente: diagnóstico, elección del tratamiento, ajuste de dosis y seguimiento.',
  value: '$37 USD',
  image: 'https://cdn.magicpatterns.com/uploads/iwn5zPL7zFPWCXWsvskJVS/BONO_1_OBESIDAD.png'
}, {
  n: '2',
  emoji: '💬',
  title: 'Scripts Médicos para Mejorar la Adherencia',
  intro: 'Descubre exactamente qué decir cuando un paciente:',
  bullets: ['Tiene miedo a los medicamentos.', 'Rechaza las inyecciones.', 'Quiere abandonar el tratamiento.', 'Cree que “la obesidad solo se resuelve con fuerza de voluntad”.'],
  outro: 'Guiones prácticos para explicar el tratamiento con claridad y aumentar la adherencia.',
  value: '$37 USD',
  image: 'https://cdn.magicpatterns.com/uploads/syuP2v2CjhakDwbYLWV9pZ/BONO_2_OBESIDAD.png'
}, {
  n: '3',
  emoji: '✅',
  title: 'Pack de Checklists Profesionales',
  intro: 'Estandariza cada consulta. Nunca vuelvas a olvidar:',
  bullets: ['Estudios iniciales.', 'Criterios diagnósticos.', 'Indicaciones farmacológicas.', 'Ajustes de tratamiento.', 'Seguimiento mensual.', 'Controles anuales.'],
  value: '$27 USD',
  image: 'https://cdn.magicpatterns.com/uploads/vkv6o4adC3S4hc1KC1eGXb/BONO_3_OBESIDAD.png'
}, {
  n: '4',
  emoji: '📋',
  title: 'Plantillas de Educación para el Paciente',
  intro: 'Material profesional listo para imprimir y entregar en consulta. Tus pacientes entenderán mejor:',
  bullets: ['Cómo funciona el tratamiento.', 'Qué resultados esperar.', 'Cómo reducir efectos secundarios.', 'Qué hábitos mantener.', 'Cuándo acudir nuevamente a consulta.'],
  outro: 'Una mejor educación significa mayor adherencia y mejores resultados clínicos.',
  value: '$47 USD',
  image: 'https://cdn.magicpatterns.com/uploads/hUde1UGx9gJAberhaeZYcz/BONO_4_OBESIDAD.png'
}, {
  n: '5',
  emoji: '🩺',
  title: 'Colección de Casos Clínicos Paso a Paso',
  intro: 'Aprende el razonamiento clínico utilizado por especialistas para resolver casos reales. Incluye escenarios como:',
  bullets: ['Paciente con diabetes tipo 2.', 'Mujer en menopausia.', 'Paciente con resistencia a la insulina.', 'Paciente con obesidad severa.', 'Estancamiento en la pérdida de peso.', 'Recuperación de peso tras el tratamiento.'],
  value: '$37 USD',
  image: 'https://cdn.magicpatterns.com/uploads/bdTu5FxC1bktFkdoE2F5bW/BONO_5_OBESIDAD.png'
}];
export function Bonuses() {
  return <section className="w-full bg-white px-4 py-14" data-id="element-32" data-mp="22kewd90ftivi">
      <div className="mx-auto max-w-2xl" data-id="element-33" data-mp="22lpw8xqri6hc">
        <div className="text-center" data-id="element-34" data-mp="1xlan6idijl56">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-gold/15 px-3 py-1 text-[11px] font-extrabold uppercase tracking-widest text-gold-dark" data-id="element-35" data-mp="1xk8yvc7hl25i">
            <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-36" data-mp="1olnmjyslyjd6" /> Bonos exclusivos
          </span>
          <h2 className="mt-4 font-display text-[26px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-37" data-mp="1jtx8piugpdh0">
            Además, hoy también recibirás estos 5 Bonos
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-[15px] leading-relaxed text-navy/65" data-id="element-38" data-mp="19w9cspl4dzx9">
            Diseñados para ayudarte a ahorrar tiempo, mejorar la adherencia de tus pacientes y tomar
            mejores decisiones desde el primer día.
          </p>
        </div>

        <div className="mt-9 space-y-5" data-id="element-39" data-mp="10wcowq6k1539">
          {BONUSES.map(bonus => <article key={bonus.n} className="overflow-hidden rounded-2xl border border-navy-100 bg-cream shadow-sm" data-id="element-40" data-mp="30z3y9jbg81yc">
              <div className="flex items-center gap-2 bg-navy px-4 py-2.5" data-id="element-41" data-mp="2r8j01wzoszfy">
                <span className="text-base" aria-hidden="true" data-id="element-42" data-mp="2r66hpiq0on2d">
                  🎁
                </span>
                <span className="text-[12px] font-extrabold uppercase tracking-widest text-gold" data-id="element-43" data-mp="2h9the1zyvayn">
                  Bono #{bonus.n}
                </span>
              </div>

              {bonus.image && <div className="bg-white px-4 pt-4" data-id="element-44" data-mp="289etcuvmbhrg">
                  <img src={bonus.image} alt={`Portada del bono ${bonus.n}: ${bonus.title}`} className="mx-auto w-full max-w-[360px]" data-id="element-45" data-mp="28azoomprb4qd" />
                </div>}

              <div className="p-4 sm:p-5" data-id="element-46" data-mp="bhem7lm281cr">
                <h3 className="font-display text-[19px] font-bold leading-snug text-navy-900 sm:text-2xl" data-id="element-47" data-mp="bgd26rn2g4iw">
                  <span aria-hidden="true" data-id="element-48" data-mp="ll1uxcwo4qxw">{bonus.emoji} </span>
                  {bonus.title}
                </h3>
                <p className="mt-2 text-[14px] leading-relaxed text-navy/70 sm:text-[15px]" data-id="element-49" data-mp="gjvyp53suljm">
                  {bonus.intro}
                </p>
                {bonus.bullets && <ul className="mt-3 space-y-1.5" data-id="element-50" data-mp="pl3rx8rgkw6u">
                    {bonus.bullets.map(b => <li key={b} className="flex gap-2 text-[14px] leading-relaxed text-navy/75" data-id="element-51" data-mp="14de4okpniui2">
                        <span className="text-green-600" aria-hidden="true" data-id="element-52" data-mp="zeaw4qagq65c">
                          ✔
                        </span>
                        <span data-id="element-53" data-mp="199us1cp114u3">{b}</span>
                      </li>)}
                  </ul>}
                {bonus.outro && <p className="mt-3 text-[14px] leading-relaxed text-navy/70" data-id="element-54" data-mp="3f5fb54zttaa4">{bonus.outro}</p>}

                <div className="mt-4 flex flex-wrap items-center gap-2" data-id="element-55" data-mp="1e14pfn3eqyog">
                  <span className="text-[13px] font-semibold text-navy/50 line-through" data-id="element-56" data-mp="1e2xw32e0tiwg">
                    Valor: {bonus.value}
                  </span>
                  <span className="rounded-full bg-green-600 px-3 py-1 text-[11px] font-extrabold uppercase tracking-wide text-white" data-id="element-57" data-mp="1nz1ap7q27a0a">
                    Hoy es tuyo gratis
                  </span>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-9 flex justify-center" data-id="element-58" data-mp="21ysgwmac3m3q">
          <CTAButton label="QUIERO EL KIT + LOS 5 BONOS" sublabel="Bonos incluidos solo en el lanzamiento" pulse={false} data-id="element-59" data-mp="21x93d3g2bp5n" />
        </div>
      </div>
    </section>;
}